<template>
    <flex-element
        tag="ul"
        class="bypass-block"
        class-default-inline="f-flex f-justify-start f-flex-col"
    >
        <collection-link
            v-for="(element, index) in elementsNew"
            :key="element.id"
            v-group:list-item
            class-default="f-w-1/1 f-relative"
            :index="index"
            :display-name="titleCase(element.elementType)"
            v-bind="element"
            :pointer="index + 1"
            is-dynamic-element
            @move-element="moveElement"
            @element-updated="elementUpdated"
            @delete-element="deleteElement"
        />

        <droppable
            type="organism"
            class="cursor-pointer f-p-0.5 f-w-1/1"
            mode="click"
            text="Click to add link"
            :is-structural-component="true"
            @click.native.stop="onAddLinkClick"
        />
    </flex-element>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import uuidv4 from 'uuid/v4';

import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { Organism, ALink } from '@/data/data-models';
import { CLEAR_SELECTED_ELEMENTS } from '@/store/types/mutation-types';
import mapFilters from '@/utils/map-filters';

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Skip Navigation',
        },
    },

    computed: {
        ...mapState({
            selectedElements: state => state.page.selectedElements,
        }),
    },

    methods: {
        ...mapFilters(['titleCase']),

        ...mapMutations({
            clearSelectedElements: CLEAR_SELECTED_ELEMENTS,
        }),

        async moveElement(direction, index) {
            let to = index;

            if (direction === 'up') {
                to = index - 1;
            } else {
                to = index + 1;
            }

            if (to < 0 || to === this.elementsNew.length) return;

            const element = this.elementsNew[index];

            this.elementsNew.splice(index, 1);
            this.elementsNew.splice(to, 0, element);
            this.setChangedData(true);

            await this.$nextTick();

            this.$root.$emit('flex::component::move');
        },

        deleteElement(index) {
            this.elementsNew.splice(index, 1);

            this.clearSelectedElements();
        },

        generateLink() {
            // until drop zone index changes, we go by length
            const pointer = this.elementsNew.length + 1;

            let listItemClasses = '';
            let linkClasses = '';

            // if this would not be the first item in the list
            if (this.elementsNew.length > 0) {
                // get the index of the newest (highest) item in the array
                const counter = this.elementsNew.length - 1;
                // get the class values for list item and link
                // for the last item in the current list
                // then update our variables to match
                listItemClasses = this.elementsNew[counter].classes;
                linkClasses = this.elementsNew[counter].elements[0].classes;
            }

            const element = new Organism({
                id: uuidv4(),
                name: `collection-link_${ pointer }`,
                elementType: 'collection-link',
                pointer,
                classes: listItemClasses,
                templateType: 'Organism',
                dataSourceId: '00000000-0000-0000-0000-000000000000',
                elements: [
                    new ALink({
                        id: uuidv4(),
                        name: 'a-link_1',
                        elementType: 'a-link',
                        pointer: 1,
                        classes: linkClasses,
                        templateType: 'a-link',
                        dataSourceId: '00000000-0000-0000-0000-000000000000',
                        elements: [],
                    }),
                ],
            });

            this.elementsNew.push(element);
        },

        onAddLinkClick() {
            this.generateLink();
        },
    },
};
</script>

<style lang="scss">
.is-editing {
    .bypass-block {
        left: auto;
        position: relative;
        z-index:1;

        a {
            position: relative;
            left: auto;
        }
    }
}
.bypass-block {
    list-style: outside none;
}
</style>
